import React from "react";
import { FilledButton } from "@nykaa/payment-ui/src/Button";
import { SubTitle } from "@nykaa/payment-ui/src/SubTitle";
import { CustomSuccessButtonLayout, CustomTextLayout, PincodeBottomSheetContentLayout } from "./assets/style";
import { PincodeBottomSheetContentConfig } from "./@types";


export const PincodeBottomSheetContent = ({
  text,
  dismissButtonText,
  onDismiss,
  font,
  dismissButtonDataTestId,
}: PincodeBottomSheetContentConfig) => (
  <PincodeBottomSheetContentLayout>
    <CustomTextLayout>
      <SubTitle
          text={text}
          font={font}
        />
    </CustomTextLayout>
    <CustomSuccessButtonLayout>
      <FilledButton
          text={dismissButtonText}
          onClick={onDismiss}
          dataTestId={dismissButtonDataTestId}
        />
    </CustomSuccessButtonLayout>
  </PincodeBottomSheetContentLayout>
  );
